"use client";

import React from "react";
import Image from "next/image";
import { useAtom } from "jotai";
import { XIcon } from "lucide-react";
import { useRouter } from "next/navigation";

import { Dialog, DialogClose, DialogContent } from "@/components/ui/dialog";
import { Paragraph } from "@/components/ui/typography";
import { Button } from "@/components/ui/button";

import { showOpenInAppModalAtom } from "@/store/modal";
import { cn } from "@/lib/utils";

function OpenInAppModal() {
  const router = useRouter();

  const [isOpen, setIsOpen] = useAtom(showOpenInAppModalAtom);

  const handleOnClick = () => {
    const isAndroid = /(android)/i.test(navigator.userAgent);

    const appLink = isAndroid
      ? "https://studyiq.page.link/Zk8q"
      : "https://apps.apple.com/in/app/adda247/id6451410946";

    router.push(appLink);
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent
        className="sm:max-w-4xl rounded-xl block space-y-4"
        showCloseButton={false}
        onInteractOutside={(event) => event.preventDefault()}
        forceMount
      >
        <DialogClose
          className={cn(
            "absolute top-0 right-0 -translate-y-1/3 translate-x-1/3 p-1.25",
            "bg-grayscale-header-weak text-primary-foreground rounded-full shadow-lg"
          )}
        >
          <XIcon />
          <span className="sr-only">Close</span>
        </DialogClose>

        <Image
          src="/studyiq-next/images/modal/open-in-app/android-img1.png"
          width={412}
          height={412}
          alt="Android Image"
        />
        <Image
          src="/studyiq-next/images/modal/open-in-app/android-img2.png"
          width={412}
          height={95}
          alt="Android Image 2"
        />
        <Paragraph variant="b2" className="text-center">
          Latest Quiz & Articles | Current Affairs & Latest Exams Information
        </Paragraph>

        <div className="flex justify-center">
          <Button onClick={handleOnClick}>Open in App</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default OpenInAppModal;
